/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import {firstValueFrom} from 'rxjs';

import {ApiConfig} from '../../app/config/api-config';
import {LocalScannedCreativeInfo} from '../session/local-scanned-creative-info';
import {AdnApiClientService} from '../../app/common/controller/adn-api-client.service';



@Injectable({
  providedIn: 'root'
})
export class AdnCheckerService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  getBlockedCreatives(forceCall?: boolean): Promise<any> {
    const blockedCreatives = LocalScannedCreativeInfo.obtain().getScannedCreatives(forceCall);
    if (blockedCreatives.length > 0) {
      return Promise.resolve(blockedCreatives);
    }
    return this.send({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['adnchecker', 'creativeblocks']),
      params: _.assign({}, {format: 'json'})
    }).then((nextBlockedCreatives: any) => {
      LocalScannedCreativeInfo.obtain().setScannedCreatives(nextBlockedCreatives);
      return nextBlockedCreatives;
    });
  }

  scanResultsByCreative(): Promise<any> {
    return this.send({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['adnchecker', 'creativeblocks']),
      params: _.assign({}, {format: 'json'})
    });
  }

  scanResults(status: string): Promise<any> {
    return this.send({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['adnchecker', 'creativeblocksbynetwork']),
      params: _.assign({}, {format: 'json', status})
    });
  }

  checkId(id: string, forceRerun?: boolean, hashResults?: boolean, ignoreScanHistory?: boolean): Promise<any> {
    return this.send({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['adnchecker', id]),
      params: _.assign({}, {
        format: 'json',
        concise: true,
        forceRerun: !!forceRerun,
        hashResults: !!hashResults,
        ignoreScanHistory: !!ignoreScanHistory
      })
    });
  }

  private send(config: any): Promise<any> {
    return firstValueFrom(this.client.request(config));
  }
}
